import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { onlyCountries } from "@/assets/onlyCountries"
import InputBox from '@/components/profile/inputBox'
import DropDown from '@/components/profile/dropDown'
import CheckBox from '@/components/profile/checkBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'

import '@/pages/profile/sections/common.css'

import "./style.css"

export default function AddressDetailsView(props: any) {
    const { profile } = useLocalTranslation();
    return (
        <div
        className={`addressDetailsView
        rounded-[10px] profileSectionCommonMainCon`}>
            {/* {topSafeComponent} */}
            <h1 className='commonH1 mt-[30px] md:mt-[0px] '>{profile.addressDetailsSection.heading}</h1>
            <div className='profileSectionOfSectionCommonMainCon'>
                <div className='commonCon1'>
                    <p>
                        {profile.addressDetailsSection.notes.n1}
                        <b>{profile.addressDetailsSection.notes.n2}</b>
                    </p>
                </div>


                {props.errMsg !== "" &&
                    <p className='commonErr1'>{props.errMsg}</p>
                }


                <div className='mb-[23px]'>
                    <InputBox
                        id="flatHouseNumber_id"
                        onChange={(e: any) => props.handleInputChange(e, "flatHouseNumber")}
                        value={props.flatHouseNumber}
                        placeholder={profile.placeHolders.flatHouseNumber}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="buildingName_id"
                        onChange={(e: any) => props.handleInputChange(e, "buildingName")}
                        value={props.buildingName}
                        placeholder={profile.placeHolders.buildingName}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="colonyName_id"
                        onChange={(e: any) => props.handleInputChange(e, "colonyName")}
                        value={props.colonyName}
                        placeholder={profile.placeHolders.colonyName}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="areaName_id"
                        onChange={(e: any) => props.handleInputChange(e, "areaName")}
                        value={props.areaName}
                        placeholder={profile.placeHolders.areaName}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="landmark_id"
                        onChange={(e: any) => props.handleInputChange(e, "landmark")}
                        value={props.landmark}
                        placeholder={profile.placeHolders.landmark}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="pincode_id"
                        onChange={(e: any) => props.handleInputChange(e, "pincode")}
                        value={props.pincode}
                        placeholder={profile.placeHolders.pincode}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <InputBox
                        id="city_id"
                        onChange={(e: any) => props.handleInputChange(e, "city")}
                        value={props.city}
                        placeholder={profile.placeHolders.city}
                        showAsterisk={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <DropDown
                        options={onlyCountries}
                        value={props.country}
                        onChange={(e: any) => props.handleInputChange(e, "country")}
                        isDropDownSearchable={true}
                        placeholder={profile.placeHolders.country}
                        customDropDownIcon={true}
                    />
                </div>

                <div className='mb-[23px]'>
                    <DropDown
                        options={props.allStates}
                        value={props.selectedState}
                        onChange={(e: any) => props.handleInputChange(e, "state")}
                        isDropDownSearchable={true}
                        placeholder={profile.placeHolders.state}
                        customDropDownIcon={true}
                    />
                </div>

                <CheckBox
                    id="addressAcknowledged_id"
                    text={profile.addressDetailsSection.notes.n3}
                    checked={props.addressAcknowledged}
                    onChange={(e: any) => props.handleOnCheckBoxChanged(e, "addressAcknowledged")}
                    showAsterisk={true}
                />

                <div className='commonBtnCon1'>
                    <RoundBlueButton
                        disabled={props.isSubmitBtnLoading}
                        onClick={() => props.handleSubmit('legalInfo')}
                    />
                </div>
            </div>
        </div>
    );
}
